import * as z from "zod";

export const getRecoverRevenueEstimate = {
  name: "getRecoverRevenueEstimate" as const,
  input: z.object({}),
  output: z.object({
    /** Number of orders the merchant placed in the last 30 days. */
    monthlyOrders: z.number().nullable(),
    /**
     * Average order value in the merchant's currency. Null when we could
     * only get the order count (no `read_reports` scope) or when the
     * merchant had no orders.
     */
    averageOrderValue: z.number().nullable(),
  }),
};
